import { render, staticRenderFns } from "./modalNotasTrabajoSocialList.vue?vue&type=template&id=0dbf6ed2"
import script from "./modalNotasTrabajoSocialList.vue?vue&type=script&lang=js"
export * from "./modalNotasTrabajoSocialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports